import AccountRecovery from './AccountRecoveryController';

export default AccountRecovery;
